import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroData } from '../../data/mock';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative h-screen overflow-hidden" data-testid="hero-section">
      {/* Background Image - Sans flou, avec overlay sombre */}
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="Les Terres de Songon"
          className="w-full h-full object-cover"
        />
        {/* Overlay sombre uniforme (35%) pour lisibilité sans flou */}
        <div className="absolute inset-0 bg-black/35" />
        {/* Gradient supplémentaire côté gauche pour le texte */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className="max-w-2xl">
            {/* Overline */}
            <p className="text-white/80 text-sm tracking-[0.3em] uppercase mb-6 animate-fadeInUp font-medium">
              Songon, Côte d'Ivoire
            </p>

            {/* Title */}
            <h1 
              className="text-5xl md:text-6xl lg:text-7xl text-white mb-8 leading-[1.1] animate-fadeInUp drop-shadow-lg"
              style={{ fontFamily: 'Playfair Display, serif', animationDelay: '0.2s' }}
              data-testid="hero-title"
            >
              {heroData.title}<br />
              <span className="italic">{heroData.titleHighlight}</span>
            </h1>

            {/* Subtitle */}
            <p 
              className="text-lg text-white/90 leading-relaxed mb-10 max-w-xl animate-fadeInUp drop-shadow-md"
              style={{ animationDelay: '0.4s' }}
            >
              {heroData.subtitle}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 animate-fadeInUp" style={{ animationDelay: '0.6s' }}>
              <Link to="/contact">
                <button 
                  className="bg-white text-[#1a1a1a] px-8 py-4 text-sm font-medium tracking-wide hover:bg-white/90 transition-all duration-300 flex items-center gap-2 shadow-lg"
                  data-testid="hero-cta-primary"
                >
                  Découvrir le projet
                  <ArrowRight className="w-4 h-4" />
                </button>
              </Link>
              <Link to="/galerie">
                <button 
                  className="border-2 border-white/50 text-white px-8 py-4 text-sm font-medium tracking-wide hover:bg-white/10 hover:border-white transition-all duration-300"
                  data-testid="hero-cta-secondary"
                >
                  Voir les résidences
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Stats - Sans blur, avec fond semi-transparent */}
        <div className="absolute bottom-0 left-0 right-0 bg-black/50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
            <div className="grid grid-cols-3 gap-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-light text-white mb-1 drop-shadow-md" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {stat.value}
                  </div>
                  <div className="text-white/80 text-sm tracking-wide font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-32 right-8 hidden lg:flex flex-col items-center gap-2">
        <div className="w-px h-16 bg-white/40" />
        <span className="text-white/70 text-xs tracking-[0.2em] uppercase font-medium" style={{ writingMode: 'vertical-rl' }}>Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
